// The upstream project fetched its furniture catalog from an Express + MongoDB
// backend. This build bundles the same catalog (Apache-2.0, from
// mehanix/arcada-backend seed data) so the app is a pure static site: nothing to
// run, nothing to pay for, and no third-party host that can disappear later.
import catalog from "./catalog.json";
import { Category, FurnitureData } from "../stores/FurnitureStore";

const byCategory = catalog.furnitureByCategory as Record<string, FurnitureData[]>;

export function spriteUrl(imagePath: string) {
    return `${process.env.PUBLIC_URL}/2d/${imagePath}.svg`;
}

export async function getCategories(): Promise<Category[]> {
    return catalog.categories as Category[];
}

export async function getCategoryInfo(categoryId: string): Promise<FurnitureData[]> {
    return byCategory[categoryId] ?? [];
}

export async function getWindow(): Promise<FurnitureData[]> {
    return catalog.window as FurnitureData[];
}

export async function getDoor(): Promise<FurnitureData[]> {
    return catalog.door as FurnitureData[];
}
